import isEmpty from 'lodash/isEmpty'
import type { Chat } from '@ztechapps/common.contract'

/** The document-link kinds a conversation carries — order, purchase order, logistics. */
export const documentLinkKinds = (chat: Chat) =>
  (['orderId', 'purchaseOrderId', 'logisticId'] as const).filter((kind) => !isEmpty(chat?.metadata?.[kind]))
